<template>
  <path
    d="M11.97 2.73018C12.13 2.39018 11.85 2.01018 11.47 2.03018C5.47 2.33018 0.999996 7.86018 2.19 13.9902C2.97 18.0202 6.28 21.2102 10.33 21.8602C14.4 22.5202 18.1 20.7202 20.2 17.7102C20.41 17.4002 20.24 16.9602 19.87 16.9202C13.13 16.1602 9 8.96018 11.97 2.73018Z"
  />
</template>
